// extracted by mini-css-extract-plugin
export var dropdownButton = "_1j-0";
export var fullWidthDropdownButton = "_1j-1";
export var icon = "_1j-3";
export var iconPlaceholder = "_1j-2";
export var shortcutContainer = "_1j-4";